import { render, staticRenderFns } from "./DashboardKpi.vue?vue&type=template&id=478cc9e4&"
import script from "./DashboardKpi.vue?vue&type=script&lang=js&"
export * from "./DashboardKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports